// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------

//Angular
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

//Services
import { authToken } from '../authToken.js';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// AuthGuard
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class AuthGuard {

    _authToken = authToken;

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(router: Router) {
        this.router = router;
    }

    //==================================
    // canActivate
    //==================================
    canActivate() {
        
        //console.log("....canActivate() called...");
        //console.log("authToken", authToken);

        if (this._authToken.isUserLoggedIn()) {
            return true;
        }
        else {
            this.router.navigate(['/publicView']);
        }
        return false;
    }
}